import { Button, useNotify } from "react-admin";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useState } from "react";
import RestoreIcon from "@material-ui/icons/Restore";
import Alert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";
import { useField } from "react-final-form";
import {
  calculateDurationInSeconds,
  getSelectedRoutePlanVersion,
  loadRoutePlanVersion,
  reformatSeconds,
  setSelectedRoutePlanVersion,
} from "../tools";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const RouteVersionButton = () => {
  const versionList = loadRoutePlanVersion();
  const selectedVersion = getSelectedRoutePlanVersion();

  const [open, setOpen] = useState<boolean>(false);
  const [tempSelectedRouteVersionId, setTempSelectedRouteVersionId] =
    useState<string>(selectedVersion.id);

  const classes = useStyles();
  const routesField = useField("routes");
  const droppedLocationsField = useField("droppedLocations");

  const notify = useNotify();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeRouteVersion = () => {
    try {
      const { routes, droppedLocations } = setSelectedRoutePlanVersion(
        tempSelectedRouteVersionId,
      );

      routesField.input.onChange(routes);
      droppedLocationsField.input.onChange(droppedLocations);

      handleClose();
    } catch (error) {
      notify(error, "error");
    }
  };

  return (
    <>
      <Button
        label="Restore to selected version"
        onClick={handleOpenDialog}
        alignIcon="right"
      >
        <RestoreIcon />
      </Button>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Route Versions</DialogTitle>
        <DialogContent>
          <Box mb={2}>
            <FormControl variant="filled" className="form-control" fullWidth>
              <InputLabel id="academicYear">Route Version</InputLabel>

              <Select
                labelId="routeVersion"
                id="routeVersion"
                value={tempSelectedRouteVersionId}
                onChange={(event: any) => {
                  setTempSelectedRouteVersionId(event.target.value);
                }}
                fullWidth
              >
                {versionList.map((value: any) => {
                  const routes = value.data?.routes || [];

                  const totalLocations = routes.reduce(
                    (sum: number, route: any) =>
                      sum + (route.routeLocations?.length - 1 || 0),
                    0,
                  );

                  const totalStudents = routes.reduce(
                    (sum: number, route: any) =>
                      sum +
                      (route.routeLocations?.reduce(
                        (locSum: number, loc: any) =>
                          locSum + (loc.students?.length || 0),
                        0,
                      ) || 0),
                    0,
                  );

                  const totalDurationSeconds = routes.reduce(
                    (sum: number, route: any) => {
                      if (!route.startTime || !route.endTime) return sum;
                      try {
                        return (
                          sum +
                          calculateDurationInSeconds(
                            route.startTime,
                            route.endTime,
                          )
                        );
                      } catch (e) {
                        return sum;
                      }
                    },
                    0,
                  );

                  const averageDurationSeconds =
                    totalDurationSeconds / routes.length;

                  return (
                    <MenuItem value={value.id} key={value.id}>
                      {value.id} - {reformatSeconds(totalDurationSeconds)} (
                      {reformatSeconds(averageDurationSeconds)}/route) -{" "}
                      {totalLocations} locations - {totalStudents} students
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

          <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
            The versioning created every time you click{" "}
            <strong>"RE-ADJUST ALL ROUTES WITH AI"</strong>. and will copied
            from the latest changes you have been made.
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleChangeRouteVersion}
            color="primary"
            label="Change Version"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RouteVersionButton;
